import { useAppSettings } from "contexts/AppSettingsContext";
import { ReactNode } from "react";
import { Navbar } from "react-bootstrap";
import { HelpLinkDropDown } from "../helplinks/HelpLinkDropDown";
import { NotificationsButton } from "../usernotifications/NotificationsButton";
import { TocNavigate } from "./TocNavigate";
import styles from "./TopBar.module.css";

/**
 * Right-hand side controls of the top bar (navigation, help, notifications, user).
 *
 * @returns A React node containing the RHS menu elements.
 */
export const RightDropMenu = (): ReactNode => {
  const appSettings = useAppSettings();

  return (
    <div
      id="rhs-menu"
      className={styles.rightNav}
    >
      <TocNavigate />
      <Navbar.Text
        id="rightdropmenu-displayname"
        className={styles.rightNavText}
      >
        {appSettings.displayName}
      </Navbar.Text>
      <HelpLinkDropDown />
      <NotificationsButton />
    </div>
  );
};

RightDropMenu.displayName = "RightDropMenu";
